/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BooleanDto
 */
export interface BooleanDto {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanDto
     */
    value?: boolean;
}

/**
 * Check if a given object implements the BooleanDto interface.
 */
export function instanceOfBooleanDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BooleanDtoFromJSON(json: any): BooleanDto {
    return BooleanDtoFromJSONTyped(json, false);
}

export function BooleanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BooleanDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function BooleanDtoToJSON(value?: BooleanDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

